/** All geometry is explicit so a standalone render matches the nested editor render. */
export type ConsumerViewSvgProps = {
  width: number;
  height: number;
  radius: number;
  background: string;
  color: string;
  tag?: string;
  fontSize: number;
  image?: string;
  imageSize: number;
  imageTop: number;
  tagBottom: number;
  quantity?: number;
};

/** Pure symbol drawing: no model access, effects, selection or interaction handlers. */
export default function ConsumerViewSvg(props: ConsumerViewSvgProps) {
  const { width, height, radius, background, color, tag, fontSize, image, imageSize, imageTop, tagBottom } = props;
  const textY = image ? height - tagBottom - fontSize * 0.2 : height / 2 + fontSize * 0.35;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}
      viewBox={`0 0 ${width} ${height}`} style={{ display: "block", overflow: "visible" }}>
      <rect width={width} height={height} rx={radius} fill={background} />
      {image && <image href={image} x={(width - imageSize) / 2} y={imageTop}
        width={imageSize} height={imageSize} preserveAspectRatio="xMidYMid meet" />}
      {tag && <text x={width / 2} y={textY} textAnchor="middle" fontFamily="Helvetica, Arial, sans-serif" fontWeight="normal"
        fontSize={fontSize} fill={color}>{tag}</text>}
      {props.quantity !== undefined && props.quantity !== 1 && (
        <g transform={`translate(20 ${15 - fontSize * 1.5})`}>
          <rect width={fontSize * 1.5} height={fontSize * 1.5} rx={fontSize * 0.75} fill="white" stroke="#aaa" />
          <text x={fontSize * 0.75} y={fontSize * 1.1} textAnchor="middle" fontSize={fontSize}
            fontFamily="Helvetica, Arial, sans-serif" fontWeight="normal" fill="#000">x{props.quantity}</text>
        </g>
      )}
    </svg>
  );
}
